import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import DesktopPopularActivities from './desktop-popular-activities'
import MobilePopularActivities from './mobile-popular-activities'

import logic from '../logic'

export default function PopularActivities () {
  const { popularActivities, popularActivitiesTitle, smallScreen, mediumScreen, largeScreen } = useValues(logic)

  const activities = popularActivities.filter(({ subCategories }) => subCategories && subCategories.length !== 0)

  return (
    <div className={`homepage-popular-activities${smallScreen ? '-tablist' : ''}`}>
      <div className='grid'>
        <div className='col-1-1'>
          <h2>{popularActivitiesTitle}</h2>
        </div>
      </div>
      {(largeScreen || mediumScreen) && <DesktopPopularActivities activities={activities} />}
      {smallScreen && <MobilePopularActivities activities={activities} />}
    </div>
  )
}
